import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

export default function Dropzone({
  accept = {
    "image/png": [".png"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/gif": [".gif"],
    "image/svg+xml": [".svg"],
  },
  message = "Déposez votre image ici",
  textColor = "blue",
  onFileUpload,
  maxSize = 5 * 1024 * 1024, // 5MB par défaut
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      setError(null);

      if (fileRejections.length > 0) {
        const errorMessage =
          fileRejections[0].errors[0].code === "file-too-large"
            ? `Le fichier est trop volumineux (max ${maxSize / 1024 / 1024}MB)`
            : "Type de fichier non supporté";
        setError(errorMessage);
        return;
      }

      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        // Validation des dimensions de l'image
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          // if (img.width > 800 || img.height > 400) {
          //   setError(
          //     "Les dimensions de l'image doivent être inférieures à 800x400px"
          //   );
          //   return;
          // }
          setUploadedFile(file);
          if (onFileUpload) {
            onFileUpload(file);
          }
        };
        img.onerror = () => {
          setError("Erreur lors du chargement de l'image");
        };
      }
    },
    [onFileUpload, maxSize]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    maxFiles: 1,
    maxSize,
  });

  return (
    <div className="max-w-full w-full">
      <div
        {...getRootProps()}
        className={`flex items-center justify-center w-full text-center border-2 border-dashed rounded-lg cursor-pointer transition-colors ${
          isDragActive
            ? "bg-gray-100 border-gray-400"
            : "bg-gray-50 border-gray-300"
        } hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500`}
      >
        <input {...getInputProps()} />
        <div className="flex flex-col items-center justify-center pt-5 pb-6 px-4 text-gray-500">
          <svg
            className="w-8 h-8 mb-2 text-gray-500"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 20 16"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
            />
          </svg>
          <h4 className="font-semibold text-gray-700">{message}</h4>
          <p className="mb-2 text-sm">
            <span className={`font-semibold text-${textColor}-500`}>
              Cliquez pour télécharger
            </span>{" "}
            ou glissez et déposez
          </p>
          <p className="text-xs text-gray-500">
            SVG, PNG, JPG ou GIF (MAX. 800x400px, {maxSize / 1024 / 1024}MB)
          </p>
          {uploadedFile && (
            <p className="mt-2 text-green-600 font-semibold text-base">
              {uploadedFile.name}
            </p>
          )}
          {error && (
            <p className="mt-2 text-red-600 font-semibold text-base">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
}
